import { render, staticRenderFns } from "./EditPowerCriteria.vue?vue&type=template&id=5643046f&scoped=true&"
import script from "./EditPowerCriteria.vue?vue&type=script&lang=js&"
export * from "./EditPowerCriteria.vue?vue&type=script&lang=js&"
import style0 from "./EditPowerCriteria.vue?vue&type=style&index=0&id=5643046f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5643046f",
  null
  
)

export default component.exports